<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <p>Sind Sie sicher, dass diese Aktion durchgeführt werden soll?</p>
            </slot>
          </div>

          <div class="modal-footer">
            <button class="btn btn-primary modal-default-button" @click="$emit('confirm')">
              {{buttonTextConfirm}}
            </button>
            <button class="btn modal-default-button" @click="$emit('cancel')">
              {{buttonTextCancel}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ModalDialog',
  emits: ['confirm', 'cancel'],
  props: {
    buttonTextConfirm: String,
    buttonTextCancel: String,
  }
});
</script>
